export const getDisplayNameElement = (displayNameState: any, key: string, identifier: string) => {
    // key = ingredients, processing,characterization etc
    // identifier = zetpol, setpct
    const foundElement = displayNameState?.[key]?.[identifier]
    return key==="user_id"?{name:"Users"}:foundElement
}